<template>
    <div class="ts-finder__resultlist-item ts-finder__resultlist-item--place" :class="{ 'ts-finder__resultlist-item--selected' : preselected }" @click="$emit('place-selected', place.place_id)">

        <!--icon-->
        <div class="ts-finder__resultlist-place-icon">
            <i class="fas fa-map-marker-alt"></i>
        </div>

        <!--details-->
        <div class="ts-finder__resultlist-details">
            <div class="ts-finder__resultlist-name">{{place.description}}</div>
        </div>
        
    </div>
</template>

<script>
    export default {
        props: ['place','preselected']
    };
</script>